import React, { useEffect, useRef, useState } from 'react'
import { DialogOverlay, DialogOverlayFooter, DialogOverlayActions, TextField, Button, Paragraph } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { deleteCmisReferences } from '../../../services/personService'
import useNotifications from '../../../hooks/useNotifications'

export default function CmisDeleteDialog({ refIds, fetchCurrentPersonUser, ...deleteDialogOpener }) {
  const { error } = useNotifications()
  const [changeReason, setChangeReason] = useState()
  const { t } = useTranslation()
  const focusElementRef = useRef()

  useEffect(() => {
    if (!deleteDialogOpener.isOpen && !deleteDialogOpener.transitioning) {
      setChangeReason()
    }
  }, [deleteDialogOpener.isOpen, deleteDialogOpener.transitioning])

  const handleDelete = async () => {
    deleteDialogOpener.close()
    // change refIds into objects
    const personIdRefObjects = []
    refIds.forEach((id) => {
      const personIdRefParts = id.split('_')
      const personId = personIdRefParts[1]
      const entityRefId = personIdRefParts[0]
      const personIdRefObject = personIdRefObjects.find((object) => object.personId === personId)
      if (personIdRefObject) {
        personIdRefObject.entityRefIds.push(entityRefId)
      } else {
        const newPersonIdRefObject = {
          personId,
          entityRefIds: [entityRefId],
        }
        personIdRefObjects.push(newPersonIdRefObject)
      }
    })
    await Promise.allSettled(
      personIdRefObjects.map((personIdRefObject) => {
        try {
          return deleteCmisReferences(personIdRefObject, changeReason)
        } catch (err) {
          error(
            t('person.cmis.errors.deletingCmisReference', {
              defaultValue: `Error deleting CMIS Reference: ${err.message || ''}`,
              message: err.message || '',
            }),
            err
          )
          return Promise.reject(err)
        }
      })
    )
    fetchCurrentPersonUser()
  }

  return (
    <DialogOverlay
      {...deleteDialogOpener}
      focusRef={focusElementRef}
      title={t('person.reference.confirmRemove', 'Confirm Remove')}
    >
      {refIds.length === 1 ? (
        <Paragraph size="sm">
          {t('person.reference.deleteSingleMessage', 'Are you sure you want to remove this CMIS Reference?')}
        </Paragraph>
      ) : (
        <Paragraph size="sm">
          {t('person.reference.deleteMultipleMessage', 'Are you sure you want to remove these CMIS References?')}
        </Paragraph>
      )}
      <TextField
        ref={focusElementRef}
        id="Change Reason"
        label={t('reason', 'Reason')}
        value={changeReason}
        onChange={(event) => setChangeReason(event.target.value)}
      />
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button id="confirmRemoveBtn" emphasis="high" onClick={handleDelete}>
            {t('action.remove', 'Remove')}
          </Button>
          <Button emphasis="medium" onClick={deleteDialogOpener.close}>
            {t('action.cancel', 'Cancel')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
